export default "__VITE_ASSET__BhCuFD4x__"